export default __webpack_public_path__ + "media/images/hero_mvp-36ba63cf94ac0c989e459a7da29a1da2.png";